import { render, staticRenderFns } from "./EditOrganizationInternationalization.vue?vue&type=template&id=13fc0370&scoped=true"
import script from "./EditOrganizationInternationalization.vue?vue&type=script&lang=js"
export * from "./EditOrganizationInternationalization.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationInternationalization.vue?vue&type=style&index=0&id=13fc0370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc0370",
  null
  
)

export default component.exports